import styled from 'styled-components'

import { avatarSizes } from 'constants/avatar'

import BaseSpinner from 'components/Spinner'
import Caption from 'components/Caption'
import { CircleButton } from 'components/Button'

import { ReactComponent as CrossIcon } from 'icons/cross-16.svg'

export const Spinner = styled(BaseSpinner)``

export const Dropzone = styled.div<{ isDragActive: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-color: ${({ theme, isDragActive }) =>
    isDragActive ? theme.colors.orange : '#d9d9d9'};

  cursor: pointer;
  user-select: none;
  * {
    pointer-events: none;
  }
`

export const Blur = styled.div`
  background-color: rgb(0, 0, 0, 0.35);
  backdrop-filter: blur(3px);
  border-radius: 7px;
`

export const RemoveButton = styled(CircleButton).attrs({
  icon: CrossIcon,
  buttonSize: '32px',
  size: '16px',
})`
  position: absolute;
  top: -16px;
  left: -16px;
  padding: 0;
  pointer-events: auto;
  color: ${({ theme }) => theme.colors.gray};

  opacity: 0;
  visibility: hidden;
  transform: translate(0, -10px);
  transition: ${({ theme }) => `
    opacity ${theme.transitions.duration[2]} ${theme.transitions.timing.easeInOut}
    transform ${theme.transitions.duration[2]} ${theme.transitions.timing.easeInOut}
    visibility ${theme.transitions.duration[2]} ${theme.transitions.timing.easeInOut}
  `};
`

export const UploadLogoCaption = styled(Caption)`
  width: 100%;
  margin-top: 0;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.small};
`

export const ChooseFile = styled.span`
  text-decoration: underline;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  :hover {
    color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  }
`

export const PreviewContainer = styled.div`
  position: relative;
  pointer-events: none;
  height: ${avatarSizes.default}px;
  background-color: ${({ theme }) => theme.colors.primaryTint[100]};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii.xxlarge};

  ${Spinner} {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  ${Blur} {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
  padding: 12px;

  border-radius: 20px; /* stylelint-disable-line scales/radii */
  border: 1px solid ${({ theme }) => theme.colors.border[2]};
  background-color: ${({ theme }) => theme.colors.background.secondary[2]};
  box-shadow: ${({ theme }) =>
    `${theme.colors.shadow.inner} 0 1px 2px 0 inset;`};

  &:hover ${/* sc-selector */ RemoveButton}:not([disabled]) {
    opacity: 1;
    transform: translate(0, 0);
    visibility: visible;
  }
`
